import React from 'react';
import moment from 'moment';

import { WpContainer, WpContainerBody, WpContainerHeader } from 'Wpds/components/container';

import './InvoicesHistory.scss';

type Props = {
  invoices: Array<{
    amount: number;
    created: number;
    pdf_url: string;
    url: string;
    status: string;
  }>;
};

function InvoicesHistory({ invoices }: Props) {
  return (
    <WpContainer>
      <WpContainerHeader>
        <h5>Invoices</h5>
      </WpContainerHeader>
      <WpContainerBody>
        <div className="invoices-history d-flex flex-column p-3">
          <div className="invoices-history-header row border-bottom text-muted py-2">
            <div className="col-3">Invoice Date </div>
            <div className="col-3">Amount</div>
            <div className="col-3">Status</div>
            <div className="col-3" />
          </div>
          {invoices.map(({ amount, created, url, pdf_url, status }) => (
            <div key={created} className="invoices-history-item row border-bottom py-2">
              <div className="col-3">{moment.unix(created).format('MMMM Do, YYYY')}</div>
              <div className="col-3">
                {(amount / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })}
              </div>
              <div className={`col-3 text-capitalize ${status.toLowerCase()}`}>{status}</div>
              <div className="col-3 text-right">
                <a href={url} target="_blank" rel="noopener noreferrer">
                  View
                </a>
                <span className="mx-2 text-muted">|</span>
                <a href={pdf_url} target="_blank" rel="noopener noreferrer">
                  Download PDF
                </a>
              </div>
            </div>
          ))}
        </div>
      </WpContainerBody>
    </WpContainer>
  );
}

export default InvoicesHistory;
